import { trackDataLayerEvent } from "../../../../../dev/front/js/dataLayer"

const EVENT_NAME = "download"
const TRACK_ATTRIBUTE = "data-download-event"

export default function initButtonDownload() {
  const links = document.querySelectorAll(`a[${TRACK_ATTRIBUTE}]`)

  links.forEach((link) => {
    link.addEventListener("click", () => {
      const payload = parsePayload(link)

      if (payload) {
        trackDataLayerEvent(EVENT_NAME, false, payload)
      }
    })
  })
}

function parsePayload(link) {
  try {
    return JSON.parse(link.getAttribute(TRACK_ATTRIBUTE))
  } catch {
    return null
  }
}
